// extracted by mini-css-extract-plugin
module.exports = {"uiChartTooltip":"_3wJxW8MW","uiChartTooltipContent":"_1_NezDRx","uiChartTooltipHeading":"_20KvZ4zx","uiChartTooltipRow":"_3RyYCEYd"};